/**
 * Split camelCase into space-separated words, preserving acronyms.
 * e.g., "veNFTs" -> "ve NFTs", "chainId" -> "chain Id"
 */
export const camelToWords = (key: string): string => {
  return key
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z]{2,})/g, "$1 $2")
    .trim();
};

/**
 * Format a camelCase or snake_case key to Title Case label
 * e.g., "myLabelSelector" -> "My Label Selector"
 * e.g., "my_label_selector" -> "My Label Selector"
 * e.g., "veNFTs" -> "Ve NFTs"
 */
export const formatLabel = (key: string): string => {
  return camelToWords(key)
    .replace(/_/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Convert a kebab-case action/node type to a human-readable display name.
 * Strips common provider prefixes and title-cases the remainder.
 * e.g., "coingecko-get-token-price" → "Get Token Price"
 * e.g., "format" → "Format"
 */
export const typeToDisplayName = (type: string): string => {
  // Strip common provider prefixes
  const stripped = type
    .replace(/^(coingecko|alchemy|moralis|chainlink|uniswap|aave|compound|slack|discord|telegram)-/, "")
    .replace(/^(send|get|check|fetch|trigger|create|update|delete)-?/, "$1 ");

  return stripped
    .split(/[-_]/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Format connector type to a readable display name
 * e.g., "pipedream:gmail" -> "Gmail"
 * e.g., "google_sheets" -> "Google Sheets"
 */
export const formatConnectorName = (connectorType: string): string => {
  return connectorType
    .replace(/^pipedream:/i, "")
    .split(/[\s:_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
